// @ts-nocheck
import Component from '@glimmer/component'
import Icon from 'customer-flows/components/ui-kit/icon'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'

export default class StepInspectorComponent extends Component {
  isStepActive = (step: FlowStep) => {
    return step.id === this.args.activeStep?.id
  }

  isStepSelected = (step: FlowStep) => {
    return step.id === this.args.selectedStep?.id
  }

  getStepClass = (step: FlowStep) => {
    return this.isStepSelected(step)
      ? 'text-theme-300'
      : 'text-neutrals-400 hover:text-theme-300'
  }

  <template>
    {{#if @open}}
      <div data-testid='step-inspector-container' class='w-full border-t border-neutrals-200 bg-neutrals-100'>
        <div data-testid='step-inspector' class='flex w-full flex-col'>
          {{#each @steps as |step|}}
            <div
              class='text-reg-para-14 flex w-full cursor-pointer items-center justify-between gap-2 border-b border-neutrals-200 px-3 py-2.5 transition-colors last:border-b-0 {{this.getStepClass step}}'
              {{on 'click' (fn @onSelectStep step)}}
            >
              <span class='flex-1 truncate' title={{step.type}}>{{step.type}}</span>
              {{#if (this.isStepActive step)}}
                <div class='rounded-1.5 flex h-5 shrink-0 items-center border border-theme-200 bg-theme-100 px-1.5 text-theme-300'>
                  <Icon @src='power' class='h-3 w-3' />
                </div>
              {{/if}}
            </div>
          {{/each}}
        </div>
      </div>
    {{/if}}
  </template>
}
